export default __webpack_public_path__ + "static/media/detail_mobile_16_2.04b71fd5.jpg";